import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';

export const enum ComposeScenario {
    Send = 0,
    Save = 1,
    Discard = 2,
}

export function logSmartReplyDatapoint(scenario: ComposeScenario, smartReplyExtractionId: string) {
    if (!smartReplyExtractionId) {
        // Nothing to log -- compose instance not created via smart reply.
        return;
    }

    let smartReplyDatapoint: any = null;
    switch (scenario) {
        case ComposeScenario.Send:
            smartReplyDatapoint = datapoints.SmartReplySendMessage;
            break;
        case ComposeScenario.Save:
            smartReplyDatapoint = datapoints.SmartReplySaveMessage;
            break;
        case ComposeScenario.Discard:
            smartReplyDatapoint = datapoints.SmartReplyDiscardMessage;
            break;
    }

    const { name: eventName, customData: customData } = smartReplyDatapoint.datapoint;
    logUsage(eventName, customData(smartReplyExtractionId));
}
